import React from 'react';

import ViewOptions, {SocialView} from 'App/views';
import { SelectableList, SelectableListOption, Unit } from 'components';
import { useMenuHideWindow, useScrollHandler } from 'hooks';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Image = styled.img`
  height: ${Unit.XL};
  width: auto;
  margin: ${Unit.XS};
`;

const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${Unit.MD} ${Unit.MD} 0;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 900;
`;

const Description = styled.h3`
  margin: 0 0 ${Unit.MD};
  font-size: 14px;
  font-weight: normal;
  text-align: center;
`;

const ListContainer = styled.div`
  flex: 1;
`;

const AboutView = () => {
  useMenuHideWindow(ViewOptions.about.id);
  const options: SelectableListOption[] = [
    {
      label: "Follow Baby Boys",
      value: () => <SocialView />,
      viewId: ViewOptions.social.id
    },
    {
      label: "Visit RRC",
      value: "Website",
      link: "https://realityrecycling.center/"
    }
  ];

  const [index] = useScrollHandler(ViewOptions.about.id, options);

  return (
    <Container>
      <ListContainer>
        <TitleContainer>
          <Image alt="iPod" src="logo512.png" />
          <Title>babyboys.sucks</Title>
        </TitleContainer>
        <Description>
          Made by Reality Recycling Center
        </Description>
        <SelectableList options={options} activeIndex={index} />
      </ListContainer>
    </Container>
  );
};

export default AboutView;
